import { CommonModule } from '@angular/common';
import { Component, ContentChild, ElementRef, Input, ViewChild } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { fromEvent, Subscription } from 'rxjs';

@Component({
  selector: 'app-page-input',
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './page-input.component.html',
  styleUrl: './page-input.component.scss'
})
export class PageInputComponent {

  @Input() placeholder!: string;
  @Input() required!: boolean;
  @Input() tooltip?: string;
  @Input() type: 'text' | 'password' | 'email' | 'number' = 'text';
  @Input() size?: string;
  @Input() maxlength?: string;
  @Input() validation?: any
  @Input() formGroup?: FormGroup;
  @Input() controlType?: string;

  inputFieldFocus: Subscription = new Subscription();

  @ViewChild('inputLabel') inputLabel!: ElementRef;
  @ContentChild('inputControl') inputControl!: ElementRef; 

  ngAfterViewInit() 
  {
    if(this.controlType == 'multiline') {
      this.inputLabel.nativeElement.classList.add("page-textarea-label");
    }
    else {
      this.inputLabel.nativeElement.classList.add("page-input-label");
    }

  }

  ngAfterContentInit() {

    this.inputFieldFocus = fromEvent(this.inputControl.nativeElement, 'focus').subscribe(() => 
      {
        if(this.controlType == 'multiline') {
          if(this.inputControl.nativeElement.value == '') {
            this.inputLabel.nativeElement.classList.toggle("page-textarea-label-is-focused");
          }
        }
        else {
          if(this.inputControl.nativeElement.value == '') {
            this.inputLabel.nativeElement.classList.toggle("page-input-label-is-focused");
          }
        }
      }
    );

    this.inputFieldFocus = fromEvent(this.inputControl.nativeElement, 'blur').subscribe(() => 
      {
        // Is it focused
        if(this.controlType == 'multiline') {
          this.inputLabel.nativeElement.classList.toggle("page-textarea-label-is-focused");
        }
        else {
          this.inputLabel.nativeElement.classList.toggle("page-input-label-is-focused");
        }

        // Is it blank
        if(this.controlType == 'multiline') {
          if(this.inputControl.nativeElement.value != '' && !this.inputControl.nativeElement.classList.contains('page-textarea-label-is-focused')) {
            this.inputLabel.nativeElement.classList.add("page-textarea-label-is-focused");
          }
          else {
            this.inputLabel.nativeElement.classList.remove("page-textarea-label-is-focused");
          }
        }
        else {
          if(this.inputControl.nativeElement.value != '' && !this.inputControl.nativeElement.classList.contains('page-input-label-is-focused')) {
            this.inputLabel.nativeElement.classList.add("page-input-label-is-focused");
          }
          else {
            this.inputLabel.nativeElement.classList.remove("page-input-label-is-focused");
          }
        }
      }
    );
  }

  ngOnDestroy() {

    // Performance reasons
    this.inputFieldFocus.unsubscribe();
  }
}
